export const START_TIMES = {
  "7 days ago": "Last 7 days",
  "30 days ago": "Last 30 days",
  "90 days ago": "Last 90 days",
  "6 months ago": "Last 6 months",
  "12 months ago": "Last 12 months"
};
